/**
 * @fileoverview Static methods for managing data.
 */
import firebase from 'firebase'

import config from './config'
import model from './model'

firebase.initializeApp(config.firebase)

const $db = firebase.database()
const $notes = $db.ref('notes')

function getNote(id: string): Promise<?model.Note> {
  return $notes.child(id).once('value')
    .then((snapshot) => snapshot.val() && model.Note.fromDb(snapshot))
}

function upsertNote(note: model.Note): Promise<model.Note> {
  return $notes.child(note.id).set(note.toDb()).then(() => note)
}

export default {getNote, upsertNote}



/** WEBPACK FOOTER **
 ** ./src/data.js
 **/